var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.115 1.5951C15.2614 1.6766 15.3763 1.80478 15.4414 1.95921C15.5065 2.11363 15.518 2.28539 15.474 2.4471L13.482 9.7501H20.75C20.8962 9.75011 21.0391 9.79283 21.1614 9.873C21.2836 9.95317 21.3797 10.0673 21.4379 10.2014C21.4961 10.3354 21.5139 10.4836 21.489 10.6276C21.4642 10.7717 21.3978 10.9053 21.298 11.0121L10.798 22.2621C10.6837 22.3849 10.5314 22.4658 10.3656 22.4919C10.1999 22.5179 10.0302 22.4876 9.88363 22.4058C9.73711 22.3241 9.62224 22.1955 9.55741 22.0407C9.49258 21.8859 9.48152 21.7139 9.52601 21.5521L11.518 14.2501H4.25001C4.10385 14.2501 3.96088 14.2074 3.83867 14.1272C3.71646 14.047 3.62034 13.9329 3.56212 13.7988C3.5039 13.6648 3.48613 13.5166 3.51098 13.3726C3.53584 13.2285 3.60223 13.0949 3.70201 12.9881L14.202 1.7381C14.3164 1.61575 14.4684 1.53519 14.6339 1.50928C14.7993 1.48336 14.9687 1.51358 15.115 1.5951Z",
    fill: "#3C45FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.b73798766bfb4b278fad952db8cdec65.svg";
export { ForwardRef as ReactComponent };